import { LazyLoader } from '@bp/ui-components';
import React, { type ComponentProps, Suspense } from 'react';
import { Notifications } from './Notifications';

type NotificationsWrapperProps = ComponentProps<typeof Notifications>;
export function NotificationsWrapper(props: NotificationsWrapperProps) {
  return (
    <Suspense fallback={<LazyLoader embedded transparent />}>
      <Notifications {...props} />
    </Suspense>
  );
}
